export const environment = {
  // API_BASE_URL: "https://dev-api.applyuninow.com",
  API_BASE_URL: "https://api.applyuninow.com",
  // API_BASE_URL: "http://localhost:3333",
};
